// Loggedout.js
 
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import titleZedLogo from './title-zedlogo.png';
import Card from 'react-bootstrap/Card';
 
function Loggedout() {
  return (
          <div className="container text-center p-4">
            <div style={{flexDirection: "column", justifyContent: "center"}}>
              <img style={{ width: 475, height: 120}} src={titleZedLogo} alt="fireSpot"/>
              <h1></h1>
            </div>
            <div className="container text-center p-4" style={{flexDirection: "column", justifyContent: "center", width: 475, height: 120}}>
              <h4>Your Zedmed Cloud session has ended</h4>
              <h4>Thank you for using Zedmed</h4>
              <div className="container text-center p-4">
                <Card.Link href="https://help.zedmed.com.au/help">Zedmed Knowledgebase</Card.Link><br/>
                <Card.Link href="https://www.zedmed.com.au/support/">Contact Zedmed Support</Card.Link><br/>
                <Card.Link href="https://www.zedmed.com.au/cloud-practice-management-software/">Find Out More About Zedmed Cloud</Card.Link>
              </div>
            </div>
          </div>
  )
}
 
export default Loggedout;